import {Component, Injectable, ViewContainerRef, TemplateRef } from '@angular/core';
import {MdDialog, MdDialogRef, MD_DIALOG_DATA, MdDialogConfig } from '@angular/material';
import { Observable } from 'rxjs/Rx';
// import {Validators} from '@angular/forms';
import { ComponentType } from '@angular/cdk/portal';
import { AppMessages } from '../../Shared/constants/messages';
import { PatientWarningComponent } from '../../components/dialog/patient-warning.component';

@Injectable()
export class PatientWarningService {

  constructor(private dialog: MdDialog) {
  }

  public getDialogConfig(){
    let config = new MdDialogConfig();
    config.disableClose = true;
    config.width = '300px';
    return config;
  }

  openDialog(data) {
    let dialogConfig = this.getDialogConfig();
    dialogConfig.data = data;
    let dialogRef = this.dialog.open(PatientWarningComponent, dialogConfig);
    return dialogRef;    
  }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/dialog/patient-warning.service.ts